import React from "react";

import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

/** Shared by the error log and the log detail pages. */

/** Stored as a JSON string: shown formatted, or as written when it is not JSON. */
export const formatJson = (value?: string | null): string | null => {
  if (!value) {
    return null;
  }

  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

export const LogField = ({
  label,
  children,
}: {
  label: string;
  children?: React.ReactNode;
}) => (
  <tr>
    <th scope="row" className="text-nowrap pr-4 align-top">
      {label}
    </th>
    <td className="text-break">{children || "—"}</td>
  </tr>
);

export const LogFields = ({ children }: { children: React.ReactNode }) => (
  <Card className="mb-3 p-3">
    <table className="mb-0">
      <tbody>{children}</tbody>
    </table>
  </Card>
);

export const LogBlocks = ({
  blocks,
}: {
  blocks: Array<{ key: string; title: string; text?: string | null }>;
}) => (
  <Accordion defaultActiveKey={blocks[0]?.key} className="mb-3">
    {blocks.map(({ key, title, text }) => (
      <Card key={key}>
        <Accordion.Toggle as={Card.Header} eventKey={key}>
          {title}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={key}>
          <Card.Body>
            <pre
              className="mb-0"
              style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
            >
              {text || "—"}
            </pre>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    ))}
  </Accordion>
);

/** "POST host/graphql/op"; jobs and libs write the same text into both fields. */
export const methodAndEndpoint = (
  method?: string | null,
  endpoint?: string | null,
) =>
  method && method !== endpoint
    ? [method, endpoint].filter(Boolean).join(" ")
    : endpoint || method || "";
